"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBox = exports.DATA_TYPES = exports.SIZES = void 0;
const util_1 = require("@app/util");
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./info-box.scss");
const ProgressCircle_1 = require("./ProgressCircle");
// define constants
var SIZES;
(function (SIZES) {
    SIZES["SMALL"] = "small";
    SIZES["LARGE"] = "large";
})(SIZES || (exports.SIZES = SIZES = {}));
var DATA_TYPES;
(function (DATA_TYPES) {
    DATA_TYPES["CURRENCY"] = "currency";
    DATA_TYPES["HOURS"] = "hours";
    DATA_TYPES["NUMBER"] = "number";
})(DATA_TYPES || (exports.DATA_TYPES = DATA_TYPES = {}));
// data component
const Data = ({ type = DATA_TYPES.NUMBER, unitInLabel = false, value = 0, sign = '', label, helpText, currency, }) => {
    // annotate return type
    const createUnitInLabel = () => {
        switch (type) {
            case DATA_TYPES.CURRENCY: {
                const currencySymbol = util_1.numberUtil.getCurrencySymbol({ currency });
                return `(${currencySymbol?.toUpperCase() ?? '??'})`;
            }
            case DATA_TYPES.HOURS:
                return `(${(0, i18n_1.t)('HOUR_SHORT')?.toUpperCase()})`;
            case DATA_TYPES.NUMBER:
                return '';
        }
    };
    const createValue = () => {
        const _value = Math.round(value * 100) / 100;
        if (unitInLabel)
            return util_1.numberUtil.localizeNumber(_value);
        switch (type) {
            case DATA_TYPES.CURRENCY:
                return util_1.numberUtil.localizeAsCurrency(_value);
            case DATA_TYPES.HOURS:
                return util_1.numberUtil.localizeAsHours(_value);
            case DATA_TYPES.NUMBER:
            default:
                return util_1.numberUtil.localizeNumber(_value);
        }
    };
    return (react_1.default.createElement("div", { className: 'data-container' },
        label && (react_1.default.createElement("div", { className: 'info-box-label' },
            label.toUpperCase(),
            unitInLabel ? ` ${createUnitInLabel()}` : '',
            helpText && (react_1.default.createElement("div", { className: 'ml-4' },
                react_1.default.createElement(_ui_1.HelpTooltip, { text: helpText }))))),
        react_1.default.createElement("span", { className: 'value' },
            sign,
            typeof value === 'number' ? createValue() : value)));
};
// InfoBox component
/**
 *
 * @deprecated Use InfoBoxV2 instead
 *
 */
const InfoBox = ({ title, progress, colorfulProgress, size = SIZES.SMALL, data, helpText, }) => {
    const [data1, data2, data3, data4] = data;
    if (data3 && size === SIZES.SMALL) {
        throw new Error('size === "small" and data.length > 2, is not implemented');
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('ds-info-box', size, {
            'has-right-side': Boolean(data3),
        }) },
        react_1.default.createElement("div", { className: 'left' },
            react_1.default.createElement("div", { className: 'top' },
                react_1.default.createElement("div", { className: 'title' },
                    title?.toUpperCase(),
                    helpText && (react_1.default.createElement("div", { className: 'ml-4' },
                        react_1.default.createElement(_ui_1.HelpTooltip, { text: helpText })))),
                (0, util_1.isUndefined)(progress) || isNaN(progress) ? null : (react_1.default.createElement(ProgressCircle_1.ProgressCircle, { progress: Math.floor(progress), size: size, colorfulProgress: colorfulProgress }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Data, { ...data1 }),
                data2 && (react_1.default.createElement("div", { className: 'mt-4' },
                    react_1.default.createElement(Data, { ...data2 }))))),
        data3 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'separator' },
                react_1.default.createElement(_ui_1.Separator, { side: _ui_1.Separator.SIDES.LEFT, size: _ui_1.Separator.SIZES.FULL_HEIGHT })),
            react_1.default.createElement("div", { className: 'right' },
                react_1.default.createElement(Data, { ...data3 }),
                data4 && (react_1.default.createElement("div", { className: 'mt-14' },
                    react_1.default.createElement(Data, { ...data4 }))))))));
};
exports.InfoBox = InfoBox;
// export constants for external usage
InfoBox.SIZES = SIZES;
InfoBox.DATA_TYPES = DATA_TYPES;
